import React from 'react';
import { Link } from '@inertiajs/react';

interface HeroSectionProps {
  title: React.ReactNode;
  subtitle: string;
  ctaRoute?: string;
  ctaText?: string;
}

export function HeroSection({
  title,
  subtitle,
  ctaRoute = '/onboarding/welcome',
  ctaText = 'Join Protribe',
}: HeroSectionProps) {
  return (
    <section className="relative overflow-hidden">
      <div className="container mx-auto px-4">
        {/* Hero Panel */}
        <div className="relative rounded-2xl overflow-hidden bg-blue-500 shadow-xl min-h-[400px] md:h-[550px] flex items-center pt-[260px] md:pt-0 pb-8 md:py-0">
          {/* Background color */}
          <div className="absolute inset-0 bg-blue-500"></div>
          
          {/* Background image - Mobile: top aligned, half height with bottom fade */}
          <div className="absolute top-0 left-0 h-1/2 w-full md:hidden">
            <img
              src="/images/landing/banner-background.png"
              alt=""
              className="h-full w-full object-cover object-top"
              style={{
                maskImage: 'linear-gradient(to bottom, black 0%, black 60%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 60%, transparent 100%)'
              }}
            />
          </div>

          {/* Background image - Desktop: right aligned with left fade */}
          <div className="absolute right-0 top-0 h-full hidden md:block">
            <img
              src="/images/landing/banner-background.png"
              alt=""
              className="h-full w-auto object-contain object-right"
              style={{
                maskImage: 'linear-gradient(to right, transparent 0%, black 30%, black 100%)',
                WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 30%, black 100%)'
              }}
            />
          </div>

          {/* Phone mockup - Mobile: top aligned with margin, 45% height with bottom fade */}
          <div className="absolute left-1/2 -translate-x-1/2 md:hidden" style={{ height: '45%', width: 'auto', top: '20px' }}>
            <img
              src="/images/landing/banner-app-preview.png"
              alt="Protribe app preview"
              className="object-contain"
              style={{
                height: '100%',
                width: 'auto',
                maxWidth: 'none',
                maskImage: 'linear-gradient(to bottom, black 0%, black 30%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(to bottom, black 0%, black 30%, transparent 100%)'
              }}
            />
          </div>

          {/* Phone mockup - Desktop: bottom right (hidden on tablet and lg, shown on xl screens) */}
          <div className="absolute bottom-0 hidden xl:flex justify-end" style={{ right: '100px' }}>
            <img
              src="/images/landing/banner-app-preview.png"
              alt="Protribe app preview"
              className="h-full w-auto object-contain"
            />
          </div>
          
          <div className="relative z-10 px-8 md:px-16 flex flex-col md:w-3/4 lg:w-2/3">
            <h1 className="text-4xl md:text-5xl text-white mb-6 font-bold leading-tight">
              {title}
            </h1>

            <p className="text-base md:text-md mb-8 max-w-full md:max-w-2/3 text-white leading-relaxed" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'normal' }}>
              {subtitle}
            </p>

            <div>
              <Link
                href={ctaRoute}
                className="inline-block px-5 py-2.5 text-sm font-semibold rounded-lg transition-colors"
                style={{ backgroundColor: '#ffc20e' }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e5af0c'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#ffc20e'}
              >
                {ctaText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 